/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { PageantRegionalTypeBaseModelIEnumerableResponseWrapper } from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class PageantRegionalTypes<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags PageantRegionalType
   * @name GetPageantRegionalTypes
   * @request GET:/PageantRegionalTypes
   */
  getPageantRegionalTypes = (params: RequestParams = {}) =>
    this.request<PageantRegionalTypeBaseModelIEnumerableResponseWrapper, any>({
      path: `/PageantRegionalTypes`,
      method: 'GET',
      format: 'json',
      ...params,
    });
}
